import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'mainlayout',
        component: () => import(/* webpackChunkName: "mainlayout" */ '../views/layout/MainLayout.vue')
    },
    {
        path: '/batch',
        name: 'batchquery',
        component: () => import(/* webpackChunkName: "batchquery" */ '../views/batch/BatchQuery.vue')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '../views/login/Login.vue')
    },
    {
        path: '*',
        component: () => import(/* webpackChunkName: "404" */ '../views/404.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    // base: process.env.BASE_URL,
    base: process.env.BASE_URL,
    routes,
})

// 路由守卫
router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token');
    // 1.如果用户访问登录页面，但是有token，跳转到首页
    if (to.path == "/login" && token) {
        next("/");
        return
    }
    // 2.如果用户访问非登录页面，但是没有token，跳转到登录页面
    if (to.path != "/login" && !token) {
        next("/login");
        return
    }
    next()
})

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
    return originalPush.call(this, location).catch(err => { })
};

export default router